import abMessages from "../Locales/Arabic_lang.json";

const ArLang = {
  messages: {
    ...abMessages,
  },
  locale: "ar-SA",
};
export default ArLang;